import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button, Result } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';

import { NimaLoadingSurface } from '@Common/nimaLoading';
import { styles } from './style';
import messages from '@Locales/config/common/messages';

const AppAsyncLoading = props => {
  const { classes, error, timedOut, pastDelay, intl } = props;

  const reloadPage = () => {
    window.location.reload();
  };

  if (error) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Result
          status="warning"
          title={<FormattedMessage {...messages.errorTitle} />}
          subTitle={<FormattedMessage {...messages.errorSubtitle} />}
          extra={
            <Button type="primary" onClick={reloadPage}>
              <FormattedMessage {...messages.reloadButton} />
            </Button>
          }
        />
      </div>
    );
  }

  if (!timedOut && !pastDelay) return null;

  /*
   * Mesma espera de pagina inteira da NIMA (apps/web/src/app/w/[workspaceSlug]/
   * loading.tsx): NimaLoadingSurface size="lg" page. O wrapper fixo continua
   * aqui porque no embed o tema forca `.block-ui { height: 100% !important }`,
   * e sem ancorar no viewport a altura nao resolve.
   */
  return (
    <div className={classes.root}>
      <NimaLoadingSurface
        className={classes.surface}
        size="lg"
        page
        label={intl.formatMessage(timedOut ? messages.loadingTimeout : messages.loadingConfig)}
      />
    </div>
  );
};

export default injectIntl(withStyles(styles)(AppAsyncLoading));
